import brand from '@helpers/brand';
import { cssVar, setCssVar } from '@helpers/cssVar';
import { Device, from, until } from '@helpers/media';
import svgAplBg from '@img/general/apl-inner-bg-pattern.svg';
import svgHhBg from '@img/general/hh-inner-bg.svg';
import HeadingStyles from '@stories/Components/Global/Typography/Heading.styles';
import SectionWrapper from '@stories/Components/SectionWrapper/SectionWrapper';
import { ReactComponent as SvgRssLogo } from '@img/general/rss-petals.svg';
import styled from 'styled-components';
import RichTextStyles from '../RichText/RichText.styles';
import LinkButtonStyles from '@stories/Components/Buttons/LinkButton/LinkButton.styles';
const Container = styled(SectionWrapper) `
  ${setCssVar('bgColor', brand.htaRebrand.green)};
  ${setCssVar('fgColor', brand.white)};
  ${setCssVar('fgColorAlt', brand.grey)};

  display: flex;
  background: ${cssVar('bgColor')};
  padding: 25px 0;
  overflow: hidden;
  position: relative;

  @media ${from(Device.MobileLarge)} {
    padding: 32px 0;
  }


  .theme-apl & {
    ${setCssVar('bgColor', brand.apl.greenLight)};
    ${setCssVar('fgColor', brand.black)};
    ${setCssVar('fgColorAlt', brand.grey)};

    background-image: url('${svgAplBg}'), url('${svgAplBg}');
  }

  .theme-hh & {
    ${setCssVar('bgColor', brand.hortHouse.green)};
    ${setCssVar('fgColor', brand.black)};
    ${setCssVar('fgColorAlt', brand.black)};

    background-image: url('${svgHhBg}');
    background-position: top left;
    background-repeat: no-repeat;
    background-size: auto 100%;
  }

  .theme-rss & {
    ${setCssVar('bgColor', brand.rss.greyLight)};
    ${setCssVar('fgColor', brand.white)};
    ${setCssVar('fgColorAlt', brand.white)};
    background-image: none;
    position: relative;
  }
`;
const Background = styled.img `
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  z-index: 0;
  display: none;

  .theme-hta & {
    display: block;
  }
`;
const Inner = styled.div `
  position: relative;
  height: 100%;
  justify-content: center;

  [data-image='true'] & {
    display: grid;
    gap: 15px;
    grid-template-columns: repeat(12, 1fr);

    @media ${from(Device.Tablet)} {
      gap: 30px;
    }
  }

  [data-image='false'] & {
    display: flex;
    align-items: center;
    flex-direction: column;
    text-align: center;
  }
`;
const BreadcrumbWrapper = styled.div `
  position: absolute;
  top: 0;
  left: 0;
  color: ${cssVar('fgColorAlt')};
  transform: translateY(-10px);

  .theme-hta & {
    color: ${cssVar('fgColor')};
  }
`;
const ContentWrapper = styled.div `
  padding: 32px 0;

  [data-image='true'] & {
    @media ${until(Device.Tablet)} {
      grid-column: 1 / span 12;
      padding: 32px 0 0;
    }

    @media ${from(Device.Tablet)} {
      grid-column: 1 / span 6;
    }

    @media ${from(Device.Desktop)} {
      grid-column: 2 / span 5;
    }
  }

  ${LinkButtonStyles.Button} {
    margin-top: 16px;
  }
`;
const Title = styled.h1 `
  ${HeadingStyles.H2Styles};

  @media ${until(Device.Tablet)} {
    font-size: 30px;
  }
`;
const Content = styled.div `
  ${RichTextStyles.contentStyles};

  p {
    @media ${until(Device.Tablet)} {
      font-size: 18px;
    }
  }

  [data-image='true'] & {
    max-width: 611px;
  }

  [data-image='false'] & {
    max-width: 100%;
  }
`;
const ImageWrapper = styled.div `
  position: relative;
  align-self: center;
  height: 0;
  padding-bottom: ${(387 / 665) * 100}%;

  @media ${until(Device.Tablet)} {
    grid-column: 1 / span 12;
  }

  @media ${from(Device.Tablet)} {
    grid-column: 7 / span 6;
  }

  @media ${from(Device.Desktop)} {
    grid-column: 7 / span 5;
  }
`;
const Image = styled.img `
  position: absolute;
  top: 0;
  left: 0;
  display: block;
  height: 100%;
  object-position: center center;
  width: 100%;

  [data-image-mode='contain'] & {
    object-fit: contain;
  }

  [data-image-mode='cover'] & {
    border-radius: 24px;
    object-fit: cover;
  }
`;
const RssLogo = styled(SvgRssLogo) `
  display: none;
  position: absolute;
  width: 143px;
  height: 88px;
  right: -75px;
  bottom: -20px;

  @media ${from(Device.Tablet)} {
    width: 250px;
    height: 155px;
    right: -125px;
    bottom: -30px;
  }

  @media ${from(Device.DesktopSmall)} {
    right: -289px;
    bottom: -70px;
    width: 577px;
    height: 358px;
  }

  .theme-rss & {
    display: block;
  }
`;
export default {
    Background,
    BreadcrumbWrapper,
    Container,
    Content,
    ContentWrapper,
    Image,
    ImageWrapper,
    Inner,
    RssLogo,
    Title,
};
